import { render, staticRenderFns } from "./VBreadcrumb.vue?vue&type=template&id=2cfe7a26&"
import script from "./VBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./VBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./VBreadcrumb.vue?vue&type=style&index=0&id=2cfe7a26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports